module.exports = __webpack_public_path__ + "static/media/bg-docsign-mobile.466cac71.png";